import React from 'react'
import moment from 'moment'
import * as htmlToImage from 'html-to-image'
import ReactPaginate from 'react-paginate'
import {Button, Box, Text, Flex, Checkbox} from '@chakra-ui/react'
import {useParams, useLocation} from 'react-router-dom'
import {MdArrowBackIos} from 'react-icons/md'
import Mau1 from './components/mau1'
import Mau2 from './components/mau2'
import Mau3 from './components/mau3'
import Mau4 from './components/mau4'
import Mau5 from './components/mau5'
import Mau6 from './components/mau6'
import Mau7 from './components/mau7'
import Mau8 from './components/mau8'
import Mau9 from './components/mau9'
import Mau10 from './components/mau10'
import Mau11 from './components/mau11'
import Mau12 from './components/mau12'
import Mau13 from './components/mau13'
import Mau14 from './components/mau14'
import Mau15 from './components/mau15'
import Mau16 from './components/mau16'
import Mau17 from './components/mau17'
import Mau18 from './components/mau18'

import {MdUpdate} from 'react-icons/md'
import imgchoose1 from '../../../public/static/image-background/bgmau1schedules.jpeg'
import imgchoose2 from '../../../public/static/image-background/c1bgmau2exportlich.jpeg'
import imgchoose3 from '../../../public/static/image-background/c2bgmau1exportlich.jpeg'
import imgchoose1us from '../../../public/static/image-background/bgmau1usschedules.jpeg'
import imgchoose2us from '../../../public/static/image-background/c1bgmau2usexportlich.jpeg'
import imgchoose3us from '../../../public/static/image-background/c2bgmau1usexportlich.jpeg'
import imgchoose4 from '../../../public/static/image-background/c2bgmau2exportlich.jpeg'
import newConceptThumbnail from '../../../public/static/image-background/newConceptThumbnail.png'
import newConceptThumbnail2 from '../../../public/static/image-background/newConceptThumbnail2.png'
import newConceptThumbnail3 from '../../../public/static/image-background/newConceptThumbnail3.png'
import newConceptThumbnail4 from '../../../public/static/image-background/newConceptThumbnail4.png'
import newConceptThumbnail5 from '../../../public/static/image-background/newConceptThumbnail5.png'
import newConceptThumbnail6 from '../../../public/static/image-background/newConceptThumbnail6.png'
import newConceptThumbnail7 from '../../../public/static/image-background/newConceptThumbnail7.png'
import newConceptThumbnail8 from '../../../public/static/image-background/newConceptThumbnail8.png'
import newConceptThumbnail9 from '../../../public/static/image-background/newConceptThumbnail9.png'
import newConceptThumbnail10 from '../../../public/static/image-background/newConceptThumbnail10.png'
import newConceptThumbnail11 from '../../../public/static/image-background/newConceptThumbnail11.png'
import newConceptThumbnail12 from '../../../public/static/image-background/newConceptThumbnail12.png'
import newConceptThumbnail13 from '../../../public/static/image-background/newConceptThumbnail13.png'
import newConceptThumbnail14 from '../../../public/static/image-background/newConceptThumbnail14.png'
import newConceptThumbnail15 from '../../../public/static/image-background/newConceptThumbnail15.png'

import * as leaguesAPI from '../../../api/leagues'
import {BrowserRouter, Routes, Route, useSearchParams} from 'react-router-dom'
import {getBase64, useTranslation} from '../../../constants/helpers'

const ExportSchedules = () => {
  const {t} = useTranslation()
  let {leagueId, seasonId} = useParams()
  const [searchParams] = useSearchParams()
  const numberRound = searchParams.get('numberRound')
  // const {isOpen, onOpen, onClose} = useDisclosure()
  const lang = window.sessionStorage.getItem('lang')
  const thumbnailImg = {
    imgbg1: {
      en: imgchoose1us,
      vi: imgchoose1
    },

    imgbg2: {
      en: imgchoose2us,
      vi: imgchoose2
    },

    imgbg3: {
      en: imgchoose3us,
      vi: imgchoose3
    }
  }
  const [type, setType] = React.useState(null)
  const [state, setState] = React.useState({
    downloading: false,
    loading: true,
    loadingTeam: true,
    dataSchedules: [],
    dataSeason: {},
    dataSponsor: [],
    loadingSponsor: true,
    loadingDataSeason: true,
    loadingDataSchedules: true,
    showSponsor: true
  })
  const [show, setShow] = React.useState(false)
  const [selected, setSelected] = React.useState(0)

  const mau1 = React.useRef(new Date().toISOString() + 'match')
  const mau2 = React.useRef(new Date().toISOString() + 'match')
  const mau3 = React.useRef(new Date().toISOString() + 'match')
  const mau4 = React.useRef(new Date().toISOString() + 'match')
  const mau5 = React.useRef(new Date().toISOString() + 'match')
  const mau6 = React.useRef(new Date().toISOString() + 'match')
  const mau7 = React.useRef(new Date().toISOString() + 'match')
  const mau8 = React.useRef(new Date().toISOString() + 'match')
  const mau9 = React.useRef(new Date().toISOString() + 'match')
  const mau10 = React.useRef(new Date().toISOString() + 'match')
  const mau11 = React.useRef(new Date().toISOString() + 'match')
  const mau12 = React.useRef(new Date().toISOString() + 'match')
  const mau13 = React.useRef(new Date().toISOString() + 'match')
  const mau14 = React.useRef(new Date().toISOString() + 'match')
  const mau15 = React.useRef(new Date().toISOString() + 'match')
  const mau16 = React.useRef(new Date().toISOString() + 'match')
  const mau17 = React.useRef(new Date().toISOString() + 'match')
  const mau18 = React.useRef(new Date().toISOString() + 'match')

  const idMau1 = mau1.current
  const idMau2 = mau2.current
  const idMau3 = mau3.current
  const idMau4 = mau4.current
  const idMau5 = mau5.current
  const idMau6 = mau6.current
  const idMau7 = mau7.current
  const idMau8 = mau8.current
  const idMau9 = mau9.current
  const idMau10 = mau10.current
  const idMau11 = mau11.current
  const idMau12 = mau12.current
  const idMau13 = mau13.current
  const idMau14 = mau14.current
  const idMau15 = mau15.current
  const idMau16 = mau16.current
  const idMau17 = mau17.current
  const idMau18 = mau18.current
  const select = value => () => {
    setSelected(value)
    setShow(true)
  }
  const fetchData = React.useCallback(() => {
    leaguesAPI
      .getSchedulesBySeasonIdV2(leagueId, seasonId, numberRound, 'all', 'all', 'all')
      .then(res => {
        setState(s => ({...s, dataSchedules: res, loadingDataSchedules: false}))
      })
      .catch(e => {
        setState(s => ({...s, loadingDataSchedules: false}))
        console.log('error', e)
      })
    leaguesAPI
      .getSeasonByIdSeasonAndIdLeague(leagueId, seasonId)
      .then(res => {
        setState(s => ({...s, dataSeason: res, loadingDataSeason: false}))
      })
      .catch(e => {
        setState(s => ({...s, loadingDataSeason: false}))
        console.log('error', e)
      })
    leaguesAPI
      .getSponsor(leagueId, seasonId)
      .then(r => {
        const dataTemp = r.reduce((p, n) => {
          if (n.sponsors.length) {
            p = [...p, ...n.sponsors]
          }
          return p
        }, [])
        setState(s => ({...s, dataSponsor: dataTemp, loadingSponsor: false}))
      })
      .catch(e => {
        setState(s => ({...s, loadingSponsor: false}))
      })
  }, [leagueId, seasonId, numberRound])

  React.useEffect(() => {
    fetchData()
  }, [fetchData])

  const handleChangeCheckbox = ({target}) => {
    setState(s => ({...s, [target.name]: target.checked}))
  }

  React.useEffect(() => {
    switch (selected) {
      case 1:
        setType(mau1.current)
        break
      case 2:
        setType(mau2.current)
        break
      case 3:
        setType(mau3.current)
        break
      case 4:
        setType(mau4.current)
        break
      case 5:
        setType(mau5.current)
        break
      case 6:
        setType(mau6.current)
        break
      case 7:
        setType(mau7.current)
        break
      case 8:
        setType(mau8.current)
        break
      case 9:
        setType(mau9.current)
        break
      case 10:
        setType(mau10.current)
        break
      case 11:
        setType(mau11.current)
        break
      case 12:
        setType(mau12.current)
        break
      case 13:
        setType(mau13.current)
        break
      case 14:
        setType(mau14.current)
        break
      case 15:
        setType(mau15.current)
        break
      case 16:
        setType(mau16.current)
        break
      case 17:
        setType(mau17.current)
        break
      case 18:
        setType(mau18.current)
        break
      default:
        break
    }
  }, [selected])

  const css = {
    cursor: 'pointer',
    border: '2px solid transparent',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    transition: 'all 0.2s ease-in-out',
    aspectRatio: '1 / 1'
  }
  /////////////
  ///////////
  /////////
  ///////

  const exportImage = async () => {
    if (state.downloading) return
    setState(s => ({...s, downloading: true}))
    htmlToImage
      .toJpeg(document.getElementById(type), {pixelRatio: 3, quality: 1})
      .then(dataUrl => {
        var link = document.createElement('a')
        const timeStamp = moment().format('yyyyMMDDHHmmss')
        const text = {
          vi: 'LichThiDau',
          en: 'Schedules'
        }
        const nameRound = t(numberRound) === numberRound ? `${t('round')} ${numberRound}` : t(numberRound) && t(numberRound) != numberRound ? `${t(numberRound)}` : ''
        link.download = `${text[lang]}_${nameRound}_${timeStamp}.jpeg`
        link.href = dataUrl
        link.click()
        setState(s => ({...s, downloading: false}))
      })
      .catch(function (error) {
        setState(s => ({...s, downloading: false}))
        console.error('oops, something went wrong!', error)
      })
  }
  React.useEffect(() => {
    // Send `message` to the parent using the postMessage method on the window.parent reference.
    window.parent.postMessage('exportSchedules', '*')
  }, [])

  if (state.loadingDataSeason || state.loadingDataSchedules) {
    return (
      <Box height={'50vh'} display="flex" flexDirection={'column'} alignItems={'center'} justifyContent="center">
        <Text> Loading . . . !</Text>
      </Box>
    )
  }
  if (show) {
    return (
      <Box>
        <Flex display={'flex'} flexDirection="row" justifyContent={'space-between'}>
          <Box
            display={'flex'}
            flexDirection={'row'}
            mb={3}
            onClick={() => {
              setShow(false)
            }}
            cursor="pointer">
            <MdArrowBackIos size={'28px'} />
            <Text>{t('back')}</Text>
          </Box>
          <Flex display="flex" flexDirection={'row'} justifyContent="flex-end">
            {state.dataSponsor.length > 0 && (
              <Checkbox textTransform={'capitalize'} mr={2} name={'showSponsor'} colorScheme="green" isChecked={state.showSponsor} onChange={handleChangeCheckbox}>
                {t('sponsor')}
              </Checkbox>
            )}
            <Button ml={4} isLoading={state.downloading} colorScheme="blue" onClick={exportImage}>
              {t('download')}
            </Button>
          </Flex>
        </Flex>
        <Flex mt={4} display={'flex'} flexDirection="row" justifyContent={'center'}>
          <Box>
            <Box maxWidth={'920px'} margin="0 auto" display="flex" flexDirection={'column'} justifyContent="center">
              {selected === 1 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau1 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau1} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau1 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 2 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau2 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau2} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau2 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 3 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau3 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau3} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau3 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 4 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau4 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau4} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau4 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 5 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau5 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau5} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau5 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 6 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau6 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau6} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau6 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 7 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau7 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau7} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau7 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 8 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau8 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau8} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau8 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 9 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau9 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau9} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau9 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 10 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau10 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau10} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau10 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 11 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau11 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau11} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau11 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 12 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau12 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau12} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau12 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 13 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau13 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau13} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau13 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 14 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau14 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau14} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau14 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 15 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau15 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau15} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau15 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 16 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau16 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau16} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau16 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 17 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau17 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau17} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau17 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 18 && (
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <Mau18 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau18} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau18 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
            </Box>
          </Box>
        </Flex>
      </Box>
    )
  } else {
    return (
      <Box height={'100%'} display="flex" flexDirection={'column'}>
        <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap="16px" w="100%">
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(1)}>
            <Image style={{margin: '0 auto', objectFit: 'contain', width: '100%', height: '100%'}} src={thumbnailImg['imgbg1'][lang]} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(2)}>
            <Image style={{margin: '0 auto', objectFit: 'contain', width: '100%', height: '100%'}} src={thumbnailImg['imgbg2'][lang]} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(3)}>
            <Image style={{margin: '0 auto', objectFit: 'contain', width: '100%', height: '100%'}} src={thumbnailImg['imgbg3'][lang]} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(4)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(5)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail2} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(6)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail3} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(7)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail4} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(8)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail5} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(9)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail6} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(10)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail7} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(11)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail8} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(12)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail9} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(13)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail10} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(14)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail11} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(15)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail12} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(16)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail13} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(17)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail14} />
          </Box>
          <Box _hover={{borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)'}} style={css} className="pointer" onClick={select(18)}>
            <Image style={{width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto'}} src={newConceptThumbnail15} />
          </Box>
        </Box>
      </Box>
    )
  }
}

const Image = props => {
  const [data, setData] = React.useState(null)
  React.useEffect(() => {
    getBase64(props.src).then(r => {
      setData(r)
    })
  }, [props.src])
  return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
  return true
}

export default React.memo(ExportSchedules, areEqual)
